import Jsona from 'jsona';

import http from '../api/http';
import { listingActions } from '../slices/listing-slice';

import config from '../../config';

export const fetchPurposes = (businessCode, countryCode) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_PURPOSE_LISTINGS_URI;

  let params = {};
  if (businessCode) {
    params = {
      ...params,
      businessCode,
    };
  }
  if (countryCode) {
    params = {
      ...params,
      countryCode,
    };
  }

  const request = http.get(apiBaseUrl, { params });

  return (dispatch) => {
    dispatch(
      listingActions.setPurposesLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const purposes = new Jsona().deserialize(data);

        dispatch(listingActions.setPurposes(purposes));
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch purposes failed!';
          }
        }

        console.log('Listing fetchPurposes error: ' + errorMessage);

        dispatch(listingActions.setPurposesError(errorMessage));
      }
    );
  };
};

export const fetchSourceOfIncomes = (businessCode, countryCode) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_SOURCE_OF_INCOME_LISTINGS_URI;

  let params = {};
  if (businessCode) {
    params = {
      ...params,
      businessCode,
    };
  }
  if (countryCode) {
    params = {
      ...params,
      countryCode,
    };
  }

  const request = http.get(apiBaseUrl, { params });

  return (dispatch) => {
    dispatch(
      listingActions.setSourceOfIncomesLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const sourceOfIncomes = new Jsona().deserialize(data);

        dispatch(listingActions.setSourceOfIncomes(sourceOfIncomes));
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch sourceOfIncomes failed!';
          }
        }

        console.log('Listing fetchSourceOfIncomes error: ' + errorMessage);

        dispatch(listingActions.setSourceOfIncomesError(errorMessage));
      }
    );
  };
};

export const fetchIdTypes = (businessCode, countryCode) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_ID_TYPES_LISTINGS_URI;

  let params = {};
  if (businessCode) {
    params = {
      ...params,
      businessCode,
    };
  }
  if (countryCode) {
    params = {
      ...params,
      countryCode,
    };
  }

  const request = http.get(apiBaseUrl, { params });

  return (dispatch) => {
    dispatch(
      listingActions.setIdTypesLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const idTypes = new Jsona().deserialize(data);

        dispatch(listingActions.setIdTypes(idTypes));
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch id types failed!';
          }
        }

        console.log('Listing fetchIdTypes error: ' + errorMessage);

        dispatch(listingActions.setIdTypesError(errorMessage));
      }
    );
  };
};

export const clearListings = () => {
  return (dispatch) => {
    dispatch(listingActions.resetListings());
  };
};
